import React, { useEffect, useState } from 'react'

import { DateRangePicker } from '../../../components/DatePicker/DateRangePicker'
import { DateObject } from '../../../helpers/date'
import { lang } from '../../../localization'
import { Template } from '../../../types/contractTemplate'

interface ContractDatePickerProps {
  template: Template
  settemplate: (t: Template) => void
}

const ContractDatePicker: React.FC<ContractDatePickerProps> = ({
  template,
  settemplate
}) => {
  const [dateObject, setdateObject] = useState<DateObject>({})
  useEffect(() => {
    if (dateObject.gregorianEndDate && dateObject.gregorianStartDate)
      settemplate({
        ...template,
        From: dateObject.gregorianStartDate,
        To: dateObject.gregorianEndDate
      })
  }, [dateObject])
  return (
    <div>
      <DateRangePicker
        dateObject={dateObject}
        onChange={(d: DateObject) => setdateObject(d)}
        hideFooterButtons
        hideShadows
        type={lang === 'fa' ? 'jalaali' : 'gregorian'}
      />
    </div>
  )
}

export default ContractDatePicker
